import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminNav = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    toast.success("Logged out successfully");
    setTimeout(() => {
      window.close();
    }, 1000);
  };

  const adminModules = [
    {
      title: "Articles",
      description: "Manage news, blogs, and content curation.",
      route: "/article-dashboard",
      gradient: "from-blue-600 to-indigo-800",
      icon: (
        <svg className="w-10 h-10 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9.5L18.5 8H20" />
        </svg>
      ),
    },
    {
      title: "Programs",
      description: "Manage events, cohorts, and applications.",
      route: "/admin-dashboard",
      gradient: "from-emerald-500 to-teal-700",
      icon: (
        <svg className="w-10 h-10 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      title: "Incubatees",
      description: "Manage startup profiles and client details.",
      route: "#",
      gradient: "from-orange-500 to-red-700",
      icon: (
        <svg className="w-10 h-10 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
    },
    {
      title: "Analytics",
      description: "View platform statistics and performance metrics.",
      route: "https://tfa.cybernestsolution.com/admin", 
      gradient: "from-purple-600 to-pink-800",
      icon: (
        <svg className="w-10 h-10 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="bg-white border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                    Admin <span className="font-normal">Dashboard</span>
                  </h1>
                  <p className="text-sm text-gray-600 mt-1">
                    View and manage the information on the platform
                  </p>
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="px-6 py-2.5 bg-gray-600 text-white rounded-lg font-medium hover:bg-gray-700 transition-all duration-200 shadow-md"
                    >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>

      <main className="flex-1 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
        <div className="mb-10 text-center sm:text-left">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Welcome Back!</h1>
          <p className="text-gray-600">Select a module below.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {adminModules.map((module, index) => (
            <div
              key={index}
              onClick={() => {
                if (module.title === "Analytics") {
                  window.open(module.route, "_blank", "noopener,noreferrer");
                } else {
                  navigate(module.route);
                }
              }}
              className={`relative overflow-hidden cursor-pointer rounded-2xl p-8 text-white shadow-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl bg-gradient-to-br ${module.gradient} group`}
            >
            <div className="absolute -right-6 -top-6 opacity-10 group-hover:opacity-20 transition-opacity duration-300 transform group-hover:scale-110">
              {module.icon}
            </div>

            <div className="relative z-10">
              {module.icon}
              <h2 className="text-2xl font-bold mb-2">{module.title}</h2>
              <p className="text-white/80 text-sm sm:text-base leading-relaxed">
                {module.description}
              </p>
            </div>
          </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default AdminNav;